const months = [
	"ENERO",
	"FEBRERO",
	"MARZO",
	"ABRIL",
	"MAYO",
	"JUNIO",
	"JULIO",
	"AGOSTO",
	"SEPTIEMBRE",
	"OCTUBRE",
	"NOVIEMBRE",
	"DICIEMBRE",
];

const weekdays = [
	"DOMINGO",
	"LUNES",
	"MARTES",
	"MIERCOLES",
	"JUEVES",
	"VIERNES",
	"SABADO",
];

export const dateToText = (date) => {
	const [year, month, day] = date.split("-");
	const weekday = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day))).getUTCDay();
	return `${weekdays[weekday]} ${day.padStart(2, "0")} DE ${months[Number(month) - 1]} DEL ${year}`;
};

export const dateToM = (date) => {
	const [, month] = date.split("-");
	return Number(month);
};

export const limitInMonths = (startDate, endDate) => {
	const [startYear,] = startDate.split("-").map(Number);
	const [endYear, endMonth] = endDate.split("-").map(Number);
	return (endYear - startYear) * 12 + endMonth;
};

export const currentDate = (days=0) => {
  let today = new Date();
  let newDate = new Date();
  newDate.setDate(today.getDate()+days);
  var dd = String(newDate.getDate()).padStart(2, '0');
  var mm = String(newDate.getMonth() + 1).padStart(2, '0');
  var yyyy = newDate.getFullYear();
  
  return `${yyyy}-${mm}-${dd}`
}